import { Cross } from '@lt/components/icons-react';
import { i18n } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';
import {
  INFORMATION_ABOUT_FLIGHT_TYPES_CLOSE_BUTTON_DATA_TEST_ID,
  INFORMATION_ABOUT_FLIGHT_TYPES_DATA_TEST_ID,
} from './constants';
import type { InformationAboutFlightTypesPropsType } from './type';

export const InformationAboutFlightTypes = ({
  className,
  onClose,
}: InformationAboutFlightTypesPropsType): JSX.Element => (
  <Container
    data-testid={INFORMATION_ABOUT_FLIGHT_TYPES_DATA_TEST_ID}
    className={className}
  >
    <Title>{i18n.t('checkout.informationAboutFlightTypes.title')}</Title>
    <Description>
      {i18n.t('checkout.informationAboutFlightTypes.description', {
        interpolation: { escapeValue: true },
      })}
    </Description>
    <Close
      onClick={onClose}
      data-testid={INFORMATION_ABOUT_FLIGHT_TYPES_CLOSE_BUTTON_DATA_TEST_ID}
    />
  </Container>
);

const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c2c5cc;
  padding: 12px 32px 16px 12px;
  white-space: pre-line;
  position: relative;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
`;

const Close = styled(Cross)`
  width: 20px;
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
`;
